module.exports = __webpack_public_path__ + "assets/auxiliary_line.752ab2b2.svg";